import React, { useEffect, useState } from 'react';
import { Container, Table, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import TransactionHistoryService from '../services/transactionHistory';
import { Transaction } from '../services/api';
import CryptoIcon from './CryptoIcons';
import Auth from './Auth';
import './TransactionHistory.css';
import './Auth.css';

const TransactionHistory: React.FC = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const transactionHistoryService = TransactionHistoryService.getInstance();

  useEffect(() => {
    // Load transaction history from local storage
    transactionHistoryService.loadFromLocalStorage();
    setTransactions(transactionHistoryService.getTransactions());
  }, []);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const formatStatus = (status: string) => {
    return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
  };

  return (
    <Auth>
      <Container className="transaction-history-container py-4">
        <h2 className="mb-4">
          <FontAwesomeIcon icon={faClock} className="me-2" />
          Transaction History
        </h2>

        {transactions.length === 0 ? (
          <div className="text-center py-4">
            <FontAwesomeIcon icon={faExchangeAlt} size="3x" className="text-muted mb-3" />
            <p className="text-muted">No transactions yet</p>
          </div>
        ) : (
          <Table responsive hover className="transaction-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>From</th>
                <th>To</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((tx) => (
                <tr key={tx.id}>
                  <td>{formatDate(tx.createdAt)}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <CryptoIcon symbol={tx.fromCurrency} size={24} className="me-2" />
                      <span>{tx.amount} {tx.fromCurrency}</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <CryptoIcon symbol={tx.toCurrency} size={24} className="me-2" />
                      <span>{tx.expectedAmount} {tx.toCurrency}</span>
                    </div>
                  </td>
                  <td>{tx.amount}</td>
                  <td>
                    <Badge bg={tx.status === 'finished' ? 'success' : 'warning'}>
                      {formatStatus(tx.status)}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Container>
    </Auth>
  );
};

export default TransactionHistory;